import { SearchModes } from '@/domainLogic/index.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { TranslationFunction } from '@/app/components/translations/Translation';
import { type ControlProps, ControlType } from '../../../../Form';
import FilterContainer from '../../FilterContainer';
import type { CommonProps } from '../CommonProps';

type GetFlightField = {
  searchParams: SearchParams;
  t: TranslationFunction;
  searchMode: SearchModes;
  commonProps: CommonProps;
};

const getFlightField = ({ searchParams, t, searchMode, commonProps }: GetFlightField): ControlProps => ({
  control: ControlType.CONTAINER,
  name: FilterContainer.FlightContainer,
  top: {
    text: `${t('vacation.oss.components.searchform.flight').charAt(0).toUpperCase()}${t('vacation.oss.components.searchform.flight').slice(1).toLowerCase()}`,
  },
  controls: [
    {
      control: ControlType.CHECKBOX,
      name: URLParameters.DIRECT,
      label: { text: t('vacation.oss.components.searchfilters.checkbox.direct') },
      value: searchParams[URLParameters.DIRECT] === '1',
      default: false,
      disabled: commonProps.isWaiting,
      className: commonProps.isSidebar || commonProps.isMobile ? 'icon-on-the-right' : '',
    },
  ],
  hide: searchMode === SearchModes.HO || searchMode === SearchModes.TH,
});

export default getFlightField;
